import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-sender-state-badge',
  templateUrl: './billing-sender-state-badge.component.html',
  styleUrls: ['./billing-sender-state-badge.component.css']
})
export class BillingSenderStateBadgeComponent implements OnInit {

  @Input() value: string;
  constructor() { }

  ngOnInit(): void {
  }

}
